<style lang="less">
@import "./TripList.less";
</style>

<template>
  <div class="trip-list">
    <van-swipe :autoplay="3000" :style="{'height': bannerHeight + 'px'}" indicator-color="#02aeff">
        <van-swipe-item v-for="(image, index) in adList" :key="index" @click="toAdLinkFn(image.to, image.url)">
          <img :alt="image.title || '欢迎您'" v-lazy="image.img_url" />
        </van-swipe-item>
      </van-swipe>
    <!--总里程-->
    <div class="trip-list-content">
      <div class="data-analyze">
        <div class="mark-wrap">
          <div class="star-wrap">
            <div class="score">{{ statisticalData.score_avg }}</div>
            <div>
              <div style="margin-bottom: 4px;">
                <!-- // >97.5  5
                  // 80  4.5
                // < 80 4 -->
                <img src="../../../assets/images/trip/star.png" width="18" height="18" v-for="item in 4" alt="">
                <img src="../../../assets/images/trip/star.png" v-if="statisticalData.score_avg >= 97.5" width="18"
                  height="18">
                <img src="../../../assets/images/trip/half-star.png"
                  v-if="statisticalData.score_avg >= 80 && statisticalData.score_avg < 97.5" width="18" height="18">
                <img src="../../../assets/images/trip/empy-star.png" v-if="statisticalData.score_avg < 80" width="18"
                  height="18">
              </div>
              <div v-if="statisticalData.increaseRate === 0">与上次一致</div>
              <div class="up-down" v-if="statisticalData.increaseRate > 0">比上次<img class="up-down-img"
                  src="../../../assets/images/trip/up.png" alt="">{{ statisticalData.increaseRate }}%</div>
              <div class="up-down" v-if="statisticalData.increaseRate < 0">比上次<img class="up-down-img"
                  src="../../../assets/images/trip/down.png" alt="">{{ statisticalData.increaseRate }}%</div>
            </div>
          </div>
          <div class="horny">
            <img src="../../../assets/images/trip/maisui.png" alt="">
            <div>
              <div>
                <img src="../../../assets/images/trip/huizhang.png" alt="">
                <span style="font-size: 16px;font-weight: 500;">车神</span>
              </div>
              <div>击败了<span style="color: #007BFE;">{{ Math.floor(statisticalData.rankRate * 100) }}%</span>的用户</div>
            </div>
            <img style="transform: rotateY(-180deg);" src="../../../assets/images/trip/maisui.png" alt="">
          </div>
        </div>
        <div class="staci-wrap">
          <div>
            <div>
              <div>{{ Math.floor(statisticalData.total_miles||0) }}km</div>
              <div>总里程</div>
            </div>
            <div>
              <div>{{ statisticalData.total_time_using }}</div>
              <div>总时长</div>
            </div>
            <div>
              <div>{{ Math.floor(statisticalData.avg_speed||0) }}km/h</div>
              <div>平均速度</div>
            </div>
          </div>
          <div>
            <div>
              <div>{{ Math.floor(statisticalData.max_speed||0) }}km/h</div>
              <div>最高速度</div>
            </div>
            <div>
              <div>{{ Math.floor(statisticalData.max_miles||0) }}km</div>
              <div>最长里程</div>
            </div>
            <div>
              <div>{{ statisticalData.total_times||0 }}段</div>
              <div>总行程</div>
            </div>
          </div>
        </div>
      </div>

        <!--没有数据-->
      <div class="no-data" v-if="!(tripList && tripList.length>0)">
        <img alt="" src="../../../assets/images/ic_no_data.png">
        <p>您还没有行程报告哦~</p>
      </div>

      <div>
        <van-list v-model="loadingGetTripList" :finished="finishedGetTripList" :immediate-check="false"
          :finished-text="tripList && tripList.length > 0 ? '没有更多数据了' : ''" :offset="30" @load="onLoadGetTripList">
          <!--循环-->
          <div v-for="item in tripList" class="item-wrap" :key="item._id" @click="toTripDetailsPage(item.trackUrl)">
            <div class="item">
              <div class="flex">
                <div>
                  <span style="font-size: 16px;color: #012;margin-right: 4px;font-weight: 500;">{{ item.finishTimeShow
                    }}</span>
                  <span style="font-size: 13px;color: #495056;margin-right: 12px;">{{ item.startToEnd }}</span>
                  <span style="font-size: 14px;color: #14BB05;" v-if="item.isAddDay">+{{item.isAddDay}}天</span>
                </div>
                <div><img src="../../../assets/images/delete.png" width="15" height="14" @click.stop="deleteTripReport(item)"
                    alt=""></div>
              </div>
              <div class="info-wrap">
                <div>
                  <img src="../../../assets/images/trip/start.png" alt="">
                  <span class="city">{{ item.startCity }}</span>
                </div>
                <div class="info-center">
                  <div style="font-size: 24px;font-weight: 600;">{{ item.spaceText }}km</div>
                  <div class="useTime">
                    <img src="../../../assets/images/trip/line.png" alt="">
                    <span>{{ item.usedTime }}</span>
                    <img style="transform: rotate(-180deg);" src="../../../assets/images/trip/line.png" alt="">
                  </div>

                </div>
                <div>
                  <img src="../../../assets/images/trip/end.png" alt="">
                  <span class="city">{{ item.endCity }}</span>
                </div>
              </div>
            </div>
            <div  v-if="item.startAddr" class="address">
              <p><label class="dot start-color"> </label><span>{{ item.startAddr }}</span></p>
              <p><label class="dot end-color"> </label><span>{{ item.endAddr }}</span></p>
            </div>
            <div v-else class="checkAddress" @click.stop="getTripAddress(item._id)" >查看详细地址</div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import TripList from './TripList.js'
export default {
  ...TripList
}
</script>
